import { css } from 'lit';
/**
 * Shared component styles
 *
 * @link https://lit.dev/docs/components/styles/#host
 */
export const baseStyles = css `
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden] {
    display: none;
  }
`;
//# sourceMappingURL=base-styles.js.map